export default "__VITE_ASSET__DiQuwPRF__"